module.exports={"(optional)":"(valgfrit)","(required)":"(påkrævet)"};